import AddEvent from './addScheduleSession';
import CopyEvent from './copyEvent';
import DeleteEvent from './deleteEvent';
import InfoEvent from './InfoEvent';
import AddInstantSession from './addInstantSession';
import Filters from '../CalendarHeader/filters';

const CalendarPopups = () => (
	<>
		<AddEvent />
		<CopyEvent />
		<DeleteEvent />
		<InfoEvent />
		<AddInstantSession />
		<Filters />
	</>
);

export default CalendarPopups;
